/**
 * Returns the authenticated user's id from localStorage.
 *
 * Phase 6.6 (Chad Identity Consolidation, L9): the legacy "default-user"
 * fallback was removed. That magic string corresponded to a real DB row
 * that has since been renamed to a proper UUID; falling back to it from
 * the frontend would now produce 404s and hide auth issues. Callers that
 * relied on the fallback should be behind an auth gate already — if
 * `userId` isn't in localStorage the user isn't logged in, period.
 *
 * Returns `null` when no userId is stored. Callers that need to ensure a
 * value should redirect to /login or short-circuit their fetches.
 */
export const getCurrentUserId = () => {
  try {
    if (typeof localStorage === 'undefined') return null;
    return localStorage.getItem('userId') || null;
  } catch {
    return null;
  }
};

export default getCurrentUserId;
